module.exports = {"id":"dp5_4l1q1","text":"Identifying Digital Competence Needs","instructions":"How often do you think about improving your digital skills for everyday life, work or learning?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"5.4","questionType":"Scale","random":false,"options":[{"id":"dp5_4l1q1-a1","text":"Almost never","score":0},{"id":"dp5_4l1q1-a2","text":"Rarely","score":0.4},{"id":"dp5_4l1q1-a3","text":"Sometimes","score":1},{"id":"dp5_4l1q1-a4","text":"Often","score":1.6},{"id":"dp5_4l1q1-a5","text":"Very often","score":2}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat5.4/l1q1.json
// module id = 1339
// module chunks = 41